<template>
  <v-dialog :value="isActive" persistent max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} configuración campaña
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 500px">
            <v-row>
              <!-- Titulo -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="alias"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.alias"
                    :error-messages="errors"
                    label="Alias"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <!-- Descripción -->
              <v-col cols="12">
                <v-row>
                  <!-- Fecha -->
                  <v-col cols="12" md="6" class="pb-0">
                    <ValidationProvider
                      name="intentos"
                      rules="required|integer"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="payload.retries"
                        :error-messages="errors"
                        label="Intentos"
                        rounded
                        filled
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <!-- Fecha -->
                  <v-col cols="12" md="6" class="pb-0">
                    <ValidationProvider
                      name="simultaneidad"
                      rules="required|integer"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="payload.simultaneity"
                        :error-messages="errors"
                        label="Simultaneidad"
                        rounded
                        filled
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>

              <!-- Tipo -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="URL"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    prepend-inner-icon="mdi-web"
                    v-model="payload.url_response"
                    :error-messages="errors"
                    label="URL"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Cola -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="asignación de agente"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-checkbox
                    v-model="payload.assignment_agent"
                    label="Asignación de agente"
                    color="primary"
                  ></v-checkbox>
                </ValidationProvider>
              </v-col>

              <!-- Tipo -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="audio"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    prepend-inner-icon="mdi-play"
                    v-model="payload.audio"
                    :error-messages="errors"
                    label="Audio"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Cola -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="Cola"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    v-model="payload.queue_id"
                    :items="queueList"
                    :error-messages="errors"
                    :loading="isLoadingQueues"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-database"
                    label="Cola"
                    filled
                    rounded
                  ></v-select>
                </ValidationProvider>
              </v-col>

              <!-- Cola -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="cliente externo"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    v-model="payload.external_id"
                    :items="externalClientList"
                    :error-messages="errors"
                    :loading="isLoadingQueues"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-database"
                    label="Cliente externo"
                    filled
                    rounded
                  ></v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn
            @click="closeDialog()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";
import vuescroll from "vuescroll";

export default {
  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      default: {},
    },
  },

  components: {
    vuescroll,
  },

  data() {
    return {
      isLoading: false,
      menuDate: false,
      menuTime: false,
      queueList: [],
      externalClientList: [],
      payload: {
        alias: "",
        retries: null,
        simultaneity: null,
        url_response: "",
        assignment_agent: null,
        audio: "",
        queue_id: null,
        external_id: null,
      },
    };
  },

  created() {
    this.getQueues();
    this.getExternalClients();
    this.payload = { ...this.dataToEdit };
  },

  methods: {
    resetform() {
      this.payload.alias = "";
      this.payload.retries = null;
      this.payload.simultaneity = null;
      this.payload.url_response = "";
      this.payload.assignment_agent = null;
      this.payload.audio = "";
      this.payload.queue_id = null;
      this.payload.external_id = null;
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async getQueues() {
      try {
        const { data } = await PbxHttpClient.get(`/clients/queues`);
        this.queueList = data.data;
        const salida = data.data.find((el) => el.name === "salida");
        if (salida) this.payload = { ...this.payload, queue: salida.number };
      } catch (err) {
        this.$snotify.error("Hubo un error consultando las colas.", "¡Error!");
      }
      this.isLoadingQueues = false;
    },

    async getExternalClients() {
      try {
        const { data } = await PbxHttpClient.get(`/clients/external/select`);
        this.externalClientList = data;
      } catch (err) {
        this.$snotify.error(
          "Hubo un error consultando los clientes externos.",
          "¡Error!"
        );
      }
      this.isLoadingQueues = false;
    },

    async submitForm() {
      this.isLoading = true;

      const accessToken = localStorage.getItem("token");

      const { id, ...payload } = this.payload;

      try {
        const { id, ...payload } = this.payload;
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(
              `/clients/configuration_external/${id}`,
              payload
            )
          : await PbxHttpClient.post(
              "/clients/configuration_external",
              payload
            );
        this.closeDialog(data.external);

        this.$snotify.success("Configuración creado con éxito.", "¡Hecho!");
      } catch (err) {
        this.isLoading = false;
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      }
    },
  },
};
</script>
